import React from 'react';
import { useAuth } from '../context/AuthContext';
import './OrganizationSwitcher.css';

function OrganizationSwitcher() {
	const { adminOrgs, orgData, switchOrganization } = useAuth();

	if (!adminOrgs || adminOrgs.length <= 1) return null;

	return (
		<div className='org-switcher'>
			<div className='org-select-container'>
				<span className='material-icons'>business</span>
				<select
					value={orgData?.id || ''}
					onChange={(e) => {
						const selectedOrg = adminOrgs.find(
							(org) => org.id === parseInt(e.target.value)
						);
						if (selectedOrg) {
							switchOrganization(selectedOrg);
						}
					}}
					className='org-select'>
					{adminOrgs.map((org) => (
						<option
							key={org.id}
							value={org.id}>
							{org.name}
						</option>
					))}
				</select>
			</div>
		</div>
	);
}

export default OrganizationSwitcher;
